/**
 * Gets a valid birthdate from localStorage if it exists
 * @returns {string|null} - The birthdate string or null if not found/valid
 */
export const getValidStoredBirthdate = () => {
  const stored = localStorage.getItem("ambassador_birthdate");
  // Check if it's null, "null", undefined, "undefined", or empty string
  if (
    !stored ||
    stored === "null" ||
    stored === "undefined" ||
    stored.trim() === ""
  ) {
    return null;
  }
  return stored;
};

/**
 * Gets a valid birthdate from URL parameters if it exists
 * @returns {string|null} - The birthdate string or null if not found/valid
 */
export const getBirthdateFromUrl = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const birthdateParam = urlParams.get("birthdate");

    if (
      birthdateParam &&
      birthdateParam !== "null" &&
      birthdateParam !== "undefined" &&
      /^\d{4}-\d{2}-\d{2}$/.test(birthdateParam)
    ) {
      return birthdateParam;
    }
  } catch (error) {
    console.error("Error getting birthdate from URL:", error);
  }
  return null;
};

/**
 * Saves birthdate to localStorage for later use
 * @param {string} birthdate - The birthdate to save
 */
export const saveBirthDateToLocalStorage = (birthdate) => {
  if (birthdate && birthdate.trim() !== "") {
    localStorage.setItem("ambassador_birthdate", birthdate);
  }
};
